export const formatPatientName = (firstName?: string, lastName?: string, middleName?: string): string => {
  const firstNameMiddleName = [firstName, middleName].filter((i) => !!i).join(" ")

  if (!firstNameMiddleName && !lastName) return "-"

  return `${lastName || "-"}, ${firstNameMiddleName || "-"}`
}
